import { Alert } from '@mui/material';
import { useSubscription } from '@/services/subscription';

export function SubscriptionBanner() {
  const { data } = useSubscription();
  if (!data || !['PAST_DUE', 'GRACE_PERIOD', 'SUSPENDED', 'EXPIRED'].includes(data.status)) {
    return null;
  }
  const message =
    data.status === 'PAST_DUE' || data.status === 'GRACE_PERIOD'
      ? 'الاشتراك في فترة سماح. راجع حالة الاشتراك لتجنب توقف عمليات الكتابة.'
      : 'انتهت صلاحية التشغيل. القراءة متاحة، بينما عمليات الكتابة متوقفة.';
  return <Alert severity="warning" sx={{ mb: 2 }}>{message}</Alert>;
}

